import { axiosInstance } from "../../../axios/axiosInstance";

const API_SYSTEM_SETTINGS_URL = "admin/system-settings";
const API_UPDATE_REFUND_URL = API_SYSTEM_SETTINGS_URL + "/update_appointment_cancel";
const API_UPDATE_PLATFORM_REVENUE_URL = API_SYSTEM_SETTINGS_URL + "/update_platform_revenue";

export const updateRefund = (dataToBeSent) => {
  return axiosInstance.post(API_UPDATE_REFUND_URL, dataToBeSent);
};

export const updatePlatformComissionPercentage = (dataToBeSent) => {
  return axiosInstance.post(API_UPDATE_PLATFORM_REVENUE_URL, dataToBeSent);
};